export const userAgreement = {
  title: "用户服务协议",
  paragraphs: [
    "前言",
    "本《用户服务协议》（以下简称“本协议”）是您（以下简称“用户”）与阿喜健康科技（北京）有限公司（以下简称“我方”、“平台运营方”）就使用本医疗智能体全部服务所订立的有效合约。您在注册账号、勾选同意、访问及使用本医疗智能体服务前，请认真阅读本协议全部条款。您的注册、登录、使用行为即表示您已充分阅读、理解并自愿接受本协议所有约束，同意受本协议及相关法律法规规范。",
    "本医疗智能体为智能健康咨询、健康数据管理、医疗知识科普、就医辅助工具类产品，所有智能回复内容仅作健康参考，不构成执业医师诊断、治疗、处方及医疗建议，不能替代线下正规医疗诊疗服务。",
    "第一条 服务说明与适用范围",
    "1.1 本协议适用于所有注册、登录、使用本医疗智能体各项功能服务的用户。",
    "1.2 我方为用户提供基于人工智能的健康问题咨询、健康档案记录、健康知识推送、就医指引、健康数据分析等辅助类医疗健康服务。",
    "1.3 我方明确声明：平台智能输出内容仅为辅助参考信息，无法适配个体病情、体征、病史差异，不作为任何诊疗依据。用户切勿仅凭平台内容自行诊断、用药、更改治疗方案，所有医疗行为请遵从线下执业医师指导。",
    "1.4 我方有权根据产品迭代、合规要求、业务调整，优化、升级、调整服务功能，如无重大权益变更，不再单独逐一通知用户。",
    "第二条 账号注册与使用规范",
    "2.1 用户需完成账号注册、实名认证（如需）后方可使用完整服务，注册时需提供真实、准确、合法、有效的手机号及相关必要信息，不得提供虚假、伪造、过期信息。",
    "2.2 用户账号仅限本人使用，不得转借、出租、出售、共享给第三方。用户对本人账号下所有操作、提问、数据记录承担全部责任。",
    "2.3 用户发现账号异常登录、信息泄露、异常操作时，应立即修改密码并联系我方客服处理，因用户自身保管不当造成的损失，由用户自行承担。",
    "2.4 注册成功后，用户可依法依规使用平台服务，同时承诺不得利用本平台从事违法违规、违背公序良俗的行为。",
    "第三条 用户权利与义务",
    "3.1 用户权利",
    "（1）合法、合规、合规范围内免费/付费使用平台公示的医疗智能服务；",
    "（2）自主查询、查看、导出本人在平台留存的健康记录、咨询记录等个人数据；",
    "（3）对平台服务缺陷、违规内容、隐私问题进行投诉、反馈、维权；",
    "（4）依法申请更正、删除本人错误或冗余个人信息及健康数据。",
    "3.2 用户义务",
    "（1）遵守《网络安全法》《个人信息保护法》《基本医疗卫生与健康促进法》等相关法律法规及本协议约定；",
    "（2）不得利用本平台发布、传播虚假医疗信息、偏方、违规诊疗内容，不得诱导他人违规就医、用药；",
    "（3）不得恶意提问、批量刷取数据、攻击平台系统、干扰平台正常运营；",
    "（4）不得上传、传播涉黄、涉暴、违法、侵权、违背公序良俗的内容及信息；",
    "（5）充分知晓平台AI服务局限性，主动规避风险，重大健康问题及时就医，不得依赖平台AI内容替代正规诊疗。",
    "第四条 平台权利与义务",
    "4.1 平台义务",
    "（1）按照本协议约定为用户提供稳定、合规的智能医疗辅助服务；",
    "（2）建立完善的数据安全与隐私保护机制，严格保护用户个人信息及健康医疗数据；",
    "（3）及时处理用户合理的咨询、投诉、信息更正与删除申请；",
    "（4）持续优化AI模型，提升内容准确性与安全性，及时修复系统漏洞。",
    "4.2 平台权利",
    "（1）对用户违规使用平台的行为，有权采取警告、内容删除、账号限制、封禁等处置措施；",
    "（2）有权对平台服务、功能、界面进行优化、升级、调整，对无效、违规数据进行清理；",
    "（3）有权依法配合监管部门、司法机关的合规查询与调查。",
    "第五条 免责声明",
    "5.1 本平台为人工智能辅助工具，非医疗机构、非执业医师，平台所有AI回复、健康分析、科普内容、风险提示均不构成医疗诊断、治疗建议、用药指导、医嘱或任何医疗执业行为。",
    "5.2 用户所有就医、诊疗、用药、康复、手术等医疗决策，需自行承担风险，建议谨遵线下执业医师医嘱，我方不对用户自行决策产生的健康损害、财产损失承担任何责任。",
    "5.3 因用户自身隐瞒病史、提供错误健康信息、无视风险提示、过度依赖AI内容导致的一切后果，由用户自行承担。",
    "5.4 因网络故障、系统维护、不可抗力、第三方服务异常导致的服务中断、数据短暂延迟，我方不承担赔偿责任。",
    "5.5 平台内容仅供通用健康科普参考，无法适配个体化、特异性、急症、重症病情，不适用急症抢救、重大疾病诊断场景。",
    "第六条 账号注销与服务终止",
    "6.1 用户可自主申请账号注销，注销后我方将依据法律法规清理、脱敏用户数据，具体以隐私政策为准。",
    "6.2 用户存在违规使用、违法传播信息、恶意攻击平台、冒用他人信息等行为的，我方有权单方终止服务、封禁账号，且无需承担任何补偿。",
    "6.3 服务终止后，本协议中关于隐私保护、免责、争议解决、数据留存的条款继续有效。",
    "第七条 协议更新与争议解决",
    "7.1 我方有权根据法律法规更新、业务调整修订本协议，修订后将在平台公示，公示后即生效，用户继续使用服务视为接受更新后协议。",
    "7.2 本协议履行过程中发生争议，双方优先友好协商解决；协商不成的，可向我方运营主体所在地有管辖权的人民法院提起诉讼。",
    "7.3 本协议未尽事宜，遵照国家现行法律法规执行。",
  ],
};

export const privacyPolicy = {
  title: "隐私政策",
  paragraphs: [
    "前言",
    "本隐私政策依据《中华人民共和国个人信息保护法》《网络安全法》《数据安全法》《基本医疗卫生与健康促进法》等法律法规制定，旨在向用户清晰说明本医疗智能体对用户个人信息、健康医疗数据的收集、使用、存储、共享、保护、删除及用户权利规则。",
    "本医疗智能体高度重视用户隐私与医疗数据安全，严格遵循合法、正当、必要、最小必要原则，仅为提供服务所需收集和使用用户信息，绝不违规泄露、滥用用户敏感医疗数据。您注册并使用本平台服务，即表示同意本隐私政策约定的全部内容。",
    "第一条 信息收集范围",
    "我方仅收集实现服务功能必需的信息，包括但不限于：",
    "1.1 注册与身份信息：手机号、验证码、账号密码、实名认证信息（如需），用于账号注册、登录核验、身份唯一识别、账号安全防护。",
    "1.2 设备与日志信息：设备型号、操作系统、登录IP、访问时间、操作记录，用于安全风控、异常登录识别、故障排查、服务优化。",
    "1.3 健康与咨询数据：用户主动输入的症状、身体情况、健康疑问、病史、用药情况、体检数据等用户自主提交的健康信息，仅用于AI智能分析、健康咨询回复、用户个人健康档案留存。",
    "1.4 用户可自主选择是否填写详细健康资料，非必要信息用户可拒绝提供，不会影响基础服务使用。",
    "第二条 信息使用目的",
    "我方收集的所有信息仅用于以下合法用途，绝不超范围使用：",
    "2.1 完成账号注册、登录、身份核验，保障账号安全与服务正常提供；",
    "2.2 为用户提供AI健康咨询、健康分析、健康记录管理、就医辅助等核心服务；",
    "2.3 优化AI模型精度、迭代产品功能、提升服务体验；",
    "2.4 进行安全风控，防范诈骗、恶意提问、系统攻击、违规使用等风险；",
    "2.5 遵守法律法规、监管要求，配合合规审查与调查；",
    "2.6 回复用户咨询、处理用户投诉与售后问题。",
    "第三条 信息存储与安全保护",
    "3.1 存储规则：用户个人信息及健康医疗数据仅存储于合规安全服务器，采取加密存储、访问权限管控机制，严格执行最小留存原则。仅在服务存续期间及法律法规要求的留存周期内保存，到期自动清理或脱敏。",
    "3.2 安全措施：我方采用行业标准的技术与管理防护措施，包括数据加密、访问审计、权限隔离、安全监控、漏洞巡检、人员保密培训等，防范数据被非法访问、泄露、篡改、丢失、滥用。",
    "3.3 内部工作人员仅因工作必要方可接触用户数据，且全程留痕审计，严禁私自查阅、导出、泄露、传播用户隐私及健康数据。",
    "第四条 信息共享与披露规则",
    "4.1 我方不会向任何无关第三方出售、出租、交易用户个人信息及医疗健康数据。",
    "4.2 仅在以下合法情形可依法依规共享或披露用户信息：",
    "（1）经用户本人明确单独同意、主动授权的情形；",
    "（2）为完成服务必需，合作第三方（技术服务商、合规核验机构）仅可在服务范围内使用，且已签署严格保密协议；",
    "（3）法律法规、司法机关、监管部门依法要求披露的情形；",
    "（4）涉及公共安全、紧急避险、保护用户及他人重大合法权益的必要情形。",
    "4.3 对外共享数据时，优先采取脱敏、去标识化处理，最大限度保护用户隐私。",
    "第五条 用户隐私权利",
    "依据《个人信息保护法》，您享有以下合法权利：",
    "5.1 知情权：您有权知晓我方收集、使用、存储、共享您信息的范围与用途。",
    "5.2 访问权：您可随时查看本人的账号信息、咨询记录、健康数据等个人留存信息。",
    "5.3 更正权：发现个人信息、健康记录不准确、不完整时，可申请更正、补充。",
    "5.4 删除权（被遗忘权）：在信息无需继续提供服务、您撤回同意、信息留存到期等情形下，可申请删除个人数据。",
    "5.5 撤回同意权：您可随时撤回后续信息授权，撤回后我方不再基于该授权继续收集使用信息，不影响此前合法处理行为的效力。",
    "5.6 注销权：您可自主申请账号注销，注销后按规则清理数据。",
    "第六条 未成年人保护",
    "6.1 若用户为未成年人，需在监护人陪同、知情、同意的情况下使用本平台服务。",
    "6.2 我方不会主动收集未成年人敏感个人信息及医疗数据，如监护人发现未成年人违规提交信息，可联系我方进行删除、清理。",
    "第七条 政策更新与通知",
    "7.1 我方可根据法律法规更新、业务合规调整修订本隐私政策，更新后将在平台注册页、个人中心公示，公示即生效。",
    "7.2 用户继续使用服务即视为同意更新后的隐私政策。",
    "第八条 咨询与维权渠道",
    "用户对本协议、隐私政策及个人信息保护有任何疑问、投诉、维权需求，可通过平台公示的客服渠道联系我方，我方将在法定时限内响应处理。",
    "生效日期：2026年05月14日",
    "运营主体：阿喜健康科技（北京）有限公司",
  ],
};

export const getLegalDoc = (type) => (type === "privacy" ? privacyPolicy : userAgreement);
